import routes from "./Routes";
import fallbackImage from "../../assets/images/fallback-image.png";
import fallbackProfileImage from "../../assets/images/fallback-profile.png";

// http://localhost:8000
// https://dev.activateuts.com.au
// https://uat.activateuts.com.au
// https://activateuts.wpengine.com

export const devHostBase = "https://dev-admin.activateuts.com.au";
// export const devHostBase = "http://localhost:3000";
const corsProxyPort = 8080;
const proxyHostname = "";
const host = process.env.REACT_APP_CORS
    ? `${document.location.protocol}//${
          proxyHostname || document.location.hostname
      }:${corsProxyPort}/${devHostBase}`
    : "" + process.env.NODE_ENV === "development"
    ? devHostBase
    : "";

export const apiBase = `${host}/wp-json`;
export const lambdaApiBase = `${host}/aws-json`;

const pageAPISubpath = "adrenalin/page";
const dynamicPageAPISubpath = "adrenalin/dynamic-page";
const userAPISubpath = `user/v1`;
const shopAPISubpath = `shop/v1`;
const recaptchaAPISubpath = `recaptcha/v1`;

const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

const Config = {
    isLocal,
    routes,
    siteName: "Activate UTS",
    siteNameSeperator: " - ",
    isIos: /^(iPhone|iPad|iPod)/.test(navigator.platform),
    fetchTimeout: 20000,
    wordpressHost: host,
    tagsCounterKey: "tagsCounter",
    tagsAPI: `${apiBase}/wp/v2/tags`,
    genericWordpressAPI: `${apiBase}/wp/v2`,
    clubsApi: `${apiBase}/wp/v2/clubs`,
    eventsApi: `${apiBase}/wp/v2/events`,
    optionsAPI: `${apiBase}/adrenalin/global_options`,
    pageAPISubpath,
    dynamicPageAPISubpath,
    userAPISubpath,
    shopAPISubpath,
    pageAPI: `${apiBase}/${pageAPISubpath}`,
    dynamicPageAPI: `${apiBase}/${dynamicPageAPISubpath}`,
    searchAPI: `${apiBase}/page/v1/search`,
    userAPI: `${apiBase}/${userAPISubpath}`,
    lambdaUserAPI: `${lambdaApiBase}/${userAPISubpath}`,
    shopAPI: `${apiBase}/${shopAPISubpath}`,
    recaptchaAPI: `${apiBase}/${recaptchaAPISubpath}`,
    nonceAPI: `${apiBase}/nonce`,
    formAPI: `${apiBase}/form/v1`,
    pageApi: `${apiBase}/page/v1`,
    recaptchaSiteKey: 
        window.recaptchaKey || `6LfmriUtAAAAADKAkuo1J4_HmKTn7KEf0jUnuei-`,
    paypalClientId:
        window.paypal_settings && window.paypal_settings.client_id
            ? window.paypal_settings.client_id
            : `AS55qtJLcbUsyDWV3UZrPE4ymPPuuRVjORADcSQp-xSKR7h17lsEQdWQ2oUezdS3SGzKoyQPoa74thQd`,
    paypalMerchantId:
        window.paypal_settings && window.paypal_settings.merchant_id
            ? window.paypal_settings.merchant_id
            : `ZR94ALUXR4KTE`,
    ewayApiKey:
        window.cc_gateway_public_key ||
        "epk-6C2C1B04-5501-4CBB-B2A8-16ED33387AED",
    fallbackFeaturedImage: fallbackImage,
    fallbackProfileImage: fallbackProfileImage,
    // defaultBreadcrumbs: [{ title: "Home", url: "/" }],
    defaultBreadcrumbs: [],
    clubBreadcrumbs: [{ title: "Clubs", url: "/clubs/" }],
    eventBreadcrumbs: [{ title: "Events", url: "/events/" }],
    wcEmptyField: "n/a",
    // user types eligible for shop discount
    discountUserTypes: ["staff", "student"],
};

export default Config;
